import { render, staticRenderFns } from "./topicLibrary.vue?vue&type=template&id=b98369f8&scoped=true&"
import script from "./topicLibrary.vue?vue&type=script&lang=js&"
export * from "./topicLibrary.vue?vue&type=script&lang=js&"
import style0 from "./topicLibrary.vue?vue&type=style&index=0&id=b98369f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98369f8",
  null
  
)

export default component.exports